import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"

interface TitleCardTWProps {
  title?: string
  subtitle?: string
  path?: string
  icon?: any
  children?: React.ReactNode
  subtitleChildren?: React.ReactNode
  delay?: string
  animationDuration?: string
}

export const TitleCardTW: React.FC<TitleCardTWProps> = ({
  title,
  subtitle,
  path,
  icon,
  children,
  subtitleChildren,
  delay = "0s",
  animationDuration = "0.6s",
}) => {
  return (
    <Animate type={AnimationTypes.fadeInTraslate} duration={animationDuration} delay={delay}>
      <div
        className="
          w-full
          bg-white
          rounded-lg
          shadow-md
          hover:shadow-md
          transition-all
          duration-300
          px-4
          py-3
          flex
          items-center
          justify-between
          gap-4
        "
      >
        <div className="flex flex-col w-full">
          <div className="flex items-center justify-between w-full">
            <div className="flex items-center gap-3">
              {icon && (
                <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-blue-100 text-blue-600">
                  <FontAwesomeIcon icon={icon} />
                </div>
              )}

              <div className="flex flex-col">
                {title && <h1 className="text-sm md:text-base font-semibold text-gray-800">{title}</h1>}

                {subtitle && <h4 className="text-xs md:text-sm font-medium text-red-500">{subtitle}</h4>}
              </div>
            </div>

            {children && <div className="flex items-center gap-2">{children}</div>}
          </div>

          {subtitleChildren && <div className="mt-2">{subtitleChildren}</div>}

          {path && <h6 className="text-xs text-gray-500 mt-1 ml-12">{path}</h6>}
        </div>
      </div>
    </Animate>
  )
}
